<template>
  <transition name="slide-fade">
    <div class="drawer-content-wrapper" :style="{width}" v-if="visible">
      <div class="drawer-content">
        <div class="drawer-wrapper-body">
          <div class="drawer-header" v-if="title">
            <a>
              <a-icon type="arrow-left" class="drawer-header-icon" />
            </a>
            <div class="drawer-title">{{title}}</div>
          </div>
          <div class="drawer-body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToolDrawer",
  props: {
    title: {
      type: String,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    width: {
      default: "256px",
      type: String,
    },
  },
  data() {
    return {
      data: [
        {
          title: "Ant Design Title 1",
        },
        {
          title: "Ant Design Title 2",
        },
        {
          title: "Ant Design Title 3",
        },
        {
          title: "Ant Design Title 4",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.slide-fade-enter-active {
  transition: all 0.5s ease;
}

.slide-fade-leave-active {
  transition: all 0.5s;
}

// .slide-fade-enter
// /* .slide-fade-leave-active for below version 2.1.8 */ {
//   transform: translateX(-210px);
//   opacity: 0;
// }

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-200px);
  opacity: 0;
}

.drawer-content-wrapper {
  width: 256px;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  height: 100%;

  left: 90px;
  position: absolute;
  //   padding: 10px;

  .drawer-content {
    width: 100%;
    height: 100%;

    position: relative;
    z-index: 1;
    overflow: auto;
    background-color: rgba(163, 163, 163, 1);
    background-clip: padding-box;
    border: 0;

    .drawer-wrapper-body {
      border-left: 4px solid rgba(123, 123, 123, 1);
      border-right: 4px solid rgba(123, 123, 123, 1);
      height: 100%;
      overflow: auto;

      .drawer-header {
        a {
          color: rgba(93, 93, 93, 1);
        }
        color: rgba(162, 162, 162, 1);
        // background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        padding: 16px 0px;
        border-bottom: 1px solid rgba(162, 162, 162, 1);
        // border-radius: 4px 4px 0 0;

        .drawer-header-icon {
          color: rgb(162, 162, 162);
        }
        .drawer-title {
          margin: 0;
          color: rgb(162, 162, 162);
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
        }
      }

      .drawer-body {
        // padding: 24px;
        font-size: 14px;
        line-height: 1.5;
        word-wrap: break-word;
        height: 100%;
        overflow-y: auto;
      }
    }
  }
}

.ant-drawer > * {
  transition: transform 0.3s cubic-bezier(0.7, 0.3, 0.1, 1),
    box-shadow 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
}

.tool-bg {
  width: 200px;
  height: 100%;
  background-color: rgba(163, 163, 163, 1);
}
</style>
